import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Badge,
    Avatar,
    Paper,
    Stack,
    useMediaQuery
} from "@mui/material";
import { useSidebarState } from "react-admin";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MailIcon from "@mui/icons-material/Mail";
import DescriptionIcon from "@mui/icons-material/Description";
import { Divider } from "@mui/material";
import ApiService from "../../functions/apiService";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { logout } from '../../context/AuthContext';
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Button from "@mui/material/Button";
import { AiOutlineMenu } from "react-icons/ai";
import moment from "moment-timezone";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "./NewTopBar.css"
import { useTheme } from "@mui/material";

export const menuStructure = {
    scheduling: {
        label: "Scheduling",
        items: [
            { path: "/firehouse/calendar", label: "Calendar" },
            { path: "/firehouse/schedule", label: "Schedule" },
            { path: "/firehouse/my-shifts", label: "My Shifts" },
            { path: "/firehouse/my-team", label: "My Team" },
            { path: "/firehouse/accept-shifts", label: "Accept Shifts" },
            { path: "/firehouse/fill-shift", label: "Fill Shifts" },
            { path: "/firehouse/fill-positions", label: "Fill Positions" },
            {path:"/firehouse/shift-calls", label:"Shift Calls"},
            { path: "/firehouse/watch-party", label: "Watch Party" },
            { path: "/firehouse/recall/pages", label: "Recall/Pages" },
            {path: "/firehouse/user-recall",label:"User Recall"},
            { path: "/firehouse/schedule-override", label: "Schedule Override" },
            {path:"/firehouse/import-schedule", label:"Import Schedule"},
            {path:"/firehouse/details", label:"Details"},
            {path:"/firehouse/overtime-signup", label: "Overtime Signup"},
            {path:"/firehouse/position-assignment", label: "Position Assignment"},
            {path:"/firehouse/cancelled-assignments", label:"Cancelled Assignments"},
            {path:"/firehouse/daily-swap-list",label:"Daily Swap List"},
            {path:"/firehouse/assignment-requests",label:"Assignment Requests"}
        ]
    },
    memberManagement: {
        label: "Member Management",
        items: [
            { path: "/firehouse/members", label: "Members" },
            { path: "/firehouse/approve-shifts", label: "Approve RTO" },
            { path: "/firehouse/Lists", label: "Lists" },
            { path: "/firehouse/manage-overtime", label: "Manage Overtime" },
            { path: "/firehouse/adjust-hours", label: "Adjust Hours" },
            {path:"/firehouse/certificates",label:"Certificates"},
            {path:"/firehouse/edit-passes",label:"Edit Passes"}
        ]
    },
    availability: {
        label: "Availability",
        items: [
            { path: "/firehouse/RTO", label: "Request RTO" },
            { path: "/firehouse/Lists", label: "Lists" },
            { path: "/firehouse/leave-book", label: "Leave Book" },
            { path: "/firehouse/overtime-signup", label: "Overtime Signup" },
            {path: "/firehouse/volunteer-signup-new",label:"volunteer Signup"},
            {path:"/firehouse/vacation-bids",label:"Vacation Bids"},
            {path:"/firehouse/vacation-bid-user",label:"My Vacation Bids"},
            {path:"/firehouse/view-bids", label:"View Bids"},
            {path:"/firehouse/off-duty-training",label:"Off Duty Training"}

        ]
    },
    inventory: {
        label: "Inventory",
        items: [
            { path: "/firehouse/inventory", label: "Inventory Management" },
            { path: "/firehouse/checklist", label: "Checklist Definition" },
            { path: "/firehouse/my-checklist", label: "My Checklist" },
            {path:"/firehouse/checklist-chief/data",label: "Daily Check View"},
            {path:"/firehouse/attribute-management",label:"Attributes"}
        ]
    },
    neris: {
        label: "NERIS",
        items: [
            { path: "/firehouse/incidents", label: "Incidents" },
            { path: "/firehouse/pre-plans", label: "Pre-Plans" },
            { path: "/firehouse/inspections", label: "Inspections" },
            { path: "/firehouse/neris-settings", label: "NERIS Settings" },
        ]
    },
    standalone: [
        { path: "/firehouse/volunteer-signup", label: "Volunteer Signup" },
        { path: "/firehouse/my-shift-calls", label: "My Shift Calls" },
        { path: "/firehouse/certificates", label: "Certificates" },
        { path: "/firehouse/payroll", label: "Payroll" },
        { path: "/firehouse/reports", label: "Reports" },
        { path: "/firehouse/messaging", label: "Messaging" },
        { path: "/firehouse/user-settings", label: "Profile" },
        { path: "/firehouse/change-password", label: "Change Password" },
    ],
     payroll: {
        label: "Payroll",
        items: [
           
            { path: "/firehouse/personal-payroll-report", label: "Personal Payroll Report" },
            { path: "/firehouse/payroll", label: "Payroll" },
            
        ]
    },
    payroll: {
        label: "Payroll",
        items: [
           
            { path: "/firehouse/personal-payroll-report", label: "Personal Payroll Report" },
            { path: "/firehouse/payroll", label: "Payroll" },
            
        ]
    },
    configuration: {
        label: "Configuration",
        items: [

            { path: "/firehouse/admin-panel", label: "Admin-Panel" },
            { path: "/firehouse/view-log", label: "View Log" },
            { path: "/firehouse/audit-log", label: "Audit Log" },
            { path: "/firehouse/config", label: "Config" },
            { path: "/firehouse/select-option", label: "Select Option" },
            { path: "/firehouse/groups-settings", label: "Group Settings" },
            {path:"/firehouse/template/management", label: "Template Management"}
            // { path: "/firehouse/payroll", label: "Payroll" },
            // { path: "/firehouse/payroll", label: "Payroll" },

        ]
    },

};

// export const generateBreadcrumbs = (pathname) => {
//     const breadcrumbs = [{ label: "Home", to: "/firehouse" }];

//     if (pathname === "/firehouse" || pathname === "/firehouse/") {
//         return breadcrumbs;
//     }

//     for (const [key, group] of Object.entries(menuStructure)) {
//         if (key === "standalone") continue;

//         const foundItem = group.items.find(item => item.path === pathname);
//         if (foundItem) {
//             breadcrumbs.push({ label: group.label, to: null });
//             breadcrumbs.push({ label: foundItem.label, to: null });
//             return breadcrumbs;
//         }
//     }

//     const standaloneItem = menuStructure.standalone.find(item => item.path === pathname);
//     if (standaloneItem) {
//         breadcrumbs.push({ label: standaloneItem.label, to: null });
//         return breadcrumbs;
//     }
//     const segments = pathname.split('/').filter(Boolean);
//     if (segments.length > 1) {
//         const pageName = segments[segments.length - 1]
//             .split('-')
//             .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//             .join(' ');
//         breadcrumbs.push({ label: pageName, to: null });
//     }

//     return breadcrumbs;
// };
// BEST SOLUTION - Replace entire generateBreadcrumbs function

export const generateBreadcrumbs = (pathname) => {
    const breadcrumbs = [{ label: "Home", to: "/firehouse" }];

    if (pathname === "/firehouse" || pathname === "/firehouse/") {
        return breadcrumbs;
    }

    // Check exact match first
    for (const [key, group] of Object.entries(menuStructure)) {
        if (key === "standalone") continue;

        const foundItem = group.items.find(item => item.path === pathname);
        if (foundItem) {
            breadcrumbs.push({ label: group.label, to: null });
            breadcrumbs.push({ label: foundItem.label, to: null });
            return breadcrumbs;
        }
    }

    const standaloneItem = menuStructure.standalone.find(item => item.path === pathname);
    if (standaloneItem) {
        breadcrumbs.push({ label: standaloneItem.label, to: null });
        return breadcrumbs;
    }

    // Parse URL segments
    const segments = pathname.split('/').filter(Boolean);
    
    // Remove "firehouse" from segments
    const routeSegments = segments.slice(1); // ["fill-position-work", "2601060745651", "a0c58e0b..."]
    
    if (routeSegments.length > 0) {
        // Always use FIRST segment after /firehouse/ as the page name
        const firstSegment = routeSegments[0];
        
        // Convert kebab-case to Title Case
        const pageName = firstSegment
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
        
        breadcrumbs.push({ label: pageName, to: null });
    }

    return breadcrumbs;
};

const NewTopBar = () => {
    const [open, setOpen] = useSidebarState(true);
    const [notificationLength, setNotificationLength] = useState([]);
    const [department, setDepartment] = useState('');
    const [name, setName] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const navigate = useNavigate();
    const [notificationAnchor, setNotificationAnchor] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const openNotifications = Boolean(notificationAnchor);
    const location = useLocation();
    const theme = useTheme(); 
    const isMobile = useMediaQuery('(max-width: 667px)');
      const isIPad = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
      const isTabletOrMobile = useMediaQuery(theme.breakpoints.down("lg"));
    const breadcrumbs = generateBreadcrumbs(location.pathname);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);

    };

    const loadNotificationsCount = () => {
        ApiService.get('/notificationsHeader')
            .then(({ data }) => {
                setNotificationLength(data?.data);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    useEffect(() => {
        const storedDepartment = localStorage.getItem('department');
        const storedName = localStorage.getItem('user');
        if (storedDepartment) {
            setDepartment(storedDepartment);
        }

        if (storedName) {
            const userName = JSON.parse(storedName);
            setName(userName.fullName);
        }
    }, []);

    useEffect(() => {
        loadNotificationsCount();
    }, []);
    const getInitials = (name = "") => {
        if (!name) return "";

        // Remove everything after '-'
        const cleanName = name.split("-")[0].trim();

        const parts = cleanName.split(" ").filter(Boolean);

        if (parts.length === 1) {
            return parts[0][0].toUpperCase();
        }

        return (
            parts[0][0].toUpperCase() +
            parts[parts.length - 1][0].toUpperCase()
        );
    };
    const handleNotificationClick = (event) => {
        setNotificationAnchor(event.currentTarget);
        loadNotifications();
    };

    const handleNotificationClose = () => {
        setNotificationAnchor(null);
    };

    const loadNotifications = () => {
        ApiService.get('/get-notification-listing?page=1&Notification_Group_Id=0&Type=Unread')
            .then(({ data }) => {
                const notificationsList = data?.data?.notifications?.data || [];
                setNotifications(notificationsList);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // The Notifications page fires this after a delete / clear-all so the bell badge
    // does not keep a stale count until the next navigation.
    useEffect(() => {
        const handleNotificationsDeleted = () => {
            loadNotificationsCount();
            loadNotifications();
        };
        window.addEventListener('notifications-deleted', handleNotificationsDeleted);
        return () => window.removeEventListener('notifications-deleted', handleNotificationsDeleted);
    }, []);

    const formatNotificationTime = (createTime) => {
        const now = moment();
        const created = moment(createTime);
        const diffInMinutes = now.diff(created, 'minutes');
        const diffInHours = now.diff(created, 'hours');
        const diffInDays = now.diff(created, 'days');

        if (diffInMinutes < 60) {
            return `${diffInMinutes}m ago`;
        } else if (diffInHours < 24) {
            return `${diffInHours}h ago`;
        } else {
            return `${diffInDays}d ago`;
        }
    };


    const ReadNotification = (item) => {
        const created = moment(item.Create_Time);
        ApiService.get(`/readNotification/${item.Notification_Id}`)
            .then(() => {
                handleNotificationClose();
                if (item.Notification_Group_Id == 1) {
                    navigate(`/firehouse/certificate-members/${item?.Certificate_id}`);
                } else if (item.Notification_Group_Id == 6) {
                    navigate(`/firehouse/my-shift-calls`);
                } else {
                    navigate(`/firehouse/schedule?date=${created.format('YYYY-MM-DD')}`);
                }
                loadNotificationsCount();
            })
            .catch((err) => {
                console.error(err);
            });
    };

    return (
        <div style={{ height: '63px', position: 'relative' }} >
            <Box
                style={{ position: 'fixed', top: 0, left: 0, zIndex: 1000 }}
                sx={{
                    width: "100%",
                    px: 3,
                    py: 1,
                    backgroundColor: "#212121",
                    borderBottom: "1px solid #364153",
                    fontFamily: "Karla, sans-serif"
                }}
                // className="menu-scroll-css"
                className="topbar"
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }} className="topbar-left" >
                   {(isMobile || isIPad ||isTabletOrMobile ) &&  <Button
                          onClick={() => setOpen(!open)}  // Toggle logic
                            sx={{
                                minWidth: '48px',
                                height: '40px',
                                backgroundColor: 'rgba(255 , 255 , 255 , 0.1)',
                                borderRadius: '6px',
                                padding: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: 'none',
                                '&:hover': {
                                    backgroundColor: '#BF1D2D',
                                    boxShadow: 'none',
                                },
                            }}
                        >
                            <AiOutlineMenu size={24} color="#ffff" />
                        </Button>}

                        <Box
                            component="img"
                            src="/images/LogoColor.svg"
                            onClick={() => navigate('/firehouse/calendar')}
                            alt="Logo"
                            className="topbar-logo"
                            sx={{
                                height: 44,
                                width: "auto",
                                cursor:'pointer'
                            }}
                        />
                        <Divider orientation="vertical" flexItem sx={{ mx: 1, backgroundColor: "#FFFFFF", borderRightWidth: "2px" }} />
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" sx={{ color: "#9CA3AF" }} />}
                            aria-label="breadcrumb"
                            className="topbar-breadcrumbs"
                        >
                            {breadcrumbs.map((item, index) => {
                                const isLast = index === breadcrumbs.length - 1;

                                return item.to ? (
                                    <Link
                                        key={index}
                                        to={item.to}
                                        style={{
                                            color: "#9CA3AF",
                                            textDecoration: "none",
                                            fontSize: "14px"
                                        }}
                                    >
                                        {item.label}
                                    </Link>
                                ) : (
                                    <Typography
                                        key={index}
                                        fontSize="14px"
                                        sx={{
                                            color: isLast ? "#FFFFFF" : "#9CA3AF",  // Only last item is white
                                            fontWeight: isLast ? 500 : 400
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                )
                            })}
                        </Breadcrumbs>

                    </Box>
                    <Stack direction="row" spacing={2} alignItems="center" className="topbar-right">
                        <Box onClick={handleNotificationClick} sx={{ cursor: 'pointer' }}>
                            <Badge badgeContent={notificationLength} color="error">
                                <NotificationsIcon sx={{ color: "#FFFFFF" }} />
                            </Badge>
                        </Box>

                        <Avatar sx={{ bgcolor: "#BF1D2D", fontWeight: 300, fontFamily: 'Arial', fontSize: '14px', width: '32px', height: '32px' }}>
                            {getInitials(name)}
                        </Avatar>
                        <Box
                            onClick={handleMenuOpen}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: 0.5
                            }}
                            className="topbar-user-info"
                        >
                            <Box>
                                <Typography fontSize={14} sx={{ color: "#FFFFFF", fontFamily: "Arial" }} className="topbar-username" >
                                    {name}
                                </Typography>
                                <Typography fontSize={12} sx={{ color: "#9CA3AF" }} className="topbar-department">
                                    {department}
                                </Typography>
                            </Box>

                            <KeyboardArrowDownIcon sx={{ color: "#FFFFFF" }} className="topbar-arrow" />
                        </Box>
                    </Stack>
                    <Menu
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                            sx: {
                                mt: 1,
                                borderRadius: "12px",
                                minWidth: 220,
                                boxShadow: "0px 4px 20px rgba(0,0,0,0.12)",
                                '& .MuiList-root': {
                                    padding: '8px 0'
                                }
                              
                            },
                              className:"account-menu-paper"
                        }}
                    >
                        <MenuItem disabled sx={{
                            opacity: 1,
                            cursor: 'default',
                            '&.Mui-disabled': {
                                opacity: 1
                            },
                            className:"menu-header",
                        }}>
                            <Typography  fontSize="15px" color="#000" style={{fontFamily:'karla',}} className="menu-header-text" >
                                My Account
                            </Typography>
                        </MenuItem>

                        <Divider sx={{ my: 0.5 }} />

                        <MenuItem onClick={() => { handleMenuClose(); navigate("/firehouse/user-settings"); }} sx={{ py: 1.5, px: 2 }} className="menu-item">
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                <PersonOutlineIcon fontSize="small" sx={{ color: '#666' }} />
                            </ListItemIcon>
                            <Typography fontSize="14px" color="#333" style={{fontFamily:'karla',}}  >Profile</Typography>
                        </MenuItem>

                        <MenuItem onClick={() => { handleMenuClose(); navigate("/firehouse/change-password"); }} sx={{ py: 1.5, px: 2 }} className="menu-item">
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                <VpnKeyIcon fontSize="small" sx={{ color: '#666' }} />
                            </ListItemIcon>
                            <Typography fontSize="14px" color="#333"  style={{fontFamily:'karla',}} >
                                Change Password
                            </Typography>
                        </MenuItem>

                        <Divider sx={{ my: 0.5 }} />

                        <MenuItem onClick={() => {
                            handleMenuClose();
                            logout();
                        }} sx={{ py: 1.5, px: 2 }} className="menu-item logout">
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                <LogoutIcon fontSize="small" sx={{ color: '#dc3545' }} />
                            </ListItemIcon>
                            <Typography fontSize="14px" color="#dc3545" fontWeight={300}  style={{fontFamily:'karla',}} >
                                Logout
                            </Typography>
                        </MenuItem>
                    </Menu>
                </Box>
            </Box>
            <Popover
                open={openNotifications}
                anchorEl={notificationAnchor}
                onClose={handleNotificationClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    className: "notification-modal",
                    sx: {
                        mt: 1,
                        width: 400,
                        maxHeight: 662,
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0px 4px 20px rgba(0,0,0,0.15)',
                        display: 'flex',
                        flexDirection: 'column',
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        maxHeight: 662,
                    }}
                >
                    {/* 🔹 HEADER */}
                    <Box
                        sx={{
                            px: 2,
                            py: 1.25, // tight spacing like design
                            backgroundColor: '#fff',
                        }}
                    >
                        <Typography
                            fontSize={16}
                            fontWeight={600}
                            lineHeight="20px"
                        >
                            Unread notifications
                        </Typography>
                    </Box>

                    <Divider sx={{ mx: 2 }} />

                    {/* 🔹 NOTIFICATION LIST */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: 'auto',
                            px: 2,
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            },
                        }}
                    >
                        <List sx={{ p: 0 }}>
                            {notifications.length === 0 ? (
                                <ListItem sx={{ py: 2, px: 0, justifyContent: 'center' }}>
                                    <Typography fontSize={14} color="text.secondary">
                                        No unread notifications
                                    </Typography>
                                </ListItem>
                            ) : (
                                notifications.map((item, index) => (
                                    <ListItem
                                        key={item.Notification_Id}
                                        onClick={() => ReadNotification(item)}
                                        sx={{
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            py: 1.5, // reduced spacing
                                            px: 0,
                                            borderBottom:
                                                index < notifications.length - 1
                                                    ? '1px solid #e0e0e0'
                                                    : 'none',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#f5f5f5',
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                width: '100%',
                                                mb: 0.25,
                                            }}
                                        >
                                            <Typography fontSize={14} fontWeight={600}>
                                                {item.Notification_Group_Id === 1
                                                    ? 'Certificate'
                                                    : item.Notification_Group_Id === 2
                                                        ? 'Schedule'
                                                        : item.Notification_Group_Id === 6
                                                            ? 'Message'
                                                            : 'Notification'}
                                            </Typography>

                                            <Typography fontSize={12} color="text.secondary">
                                                {formatNotificationTime(item.Create_Time)}
                                            </Typography>
                                        </Box>

                                        <Typography fontSize={14} color="text.secondary">
                                            {item.Description.replace(
                                                /\d{4}-\d{2}-\d{2}/,
                                                (match) => moment(match).format('MM/DD/YYYY')
                                            )}
                                        </Typography>
                                    </ListItem>
                                ))
                            )}
                        </List>
                    </Box>

                    {/* 🔹 FOOTER */}
                    <Box
                        sx={{
                            p: 1.5,
                            borderTop: '1px solid #e0e0e0',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                        }}
                    >
                        <Button
                            onClick={() => {
                                handleNotificationClose();
                                navigate('/firehouse/notifications');
                            }}
                            sx={{
                                color: '#BF1D2D',
                                textTransform: 'none',
                                fontSize: 14,
                                fontWeight: 500,
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            See all notifications
                        </Button>
                    </Box>
                </Box>
            </Popover>

        </div>

    );
};


export default NewTopBar;
